import { Container } from "unstated"

import api from "../utils/api"
import deserialize from "../utils/deserialize"
import { toastSuccess, toastError } from "../utils/myToasts"

class NotificationStore extends Container {
  state = {
    loading: false,
    notifications: [],
    pagination: {},
    hasUnread: false,
    socket: null,
    hasLoaded: false,
  }

  fetchNotifications = async (page = 1, limit = 5) => {
    if (this.state.loading) return
    this.setState({ loading: true })
    try {
      const res = await api.get(`/notifications?page=${page}&limit=${limit}`)
      const notifications = await deserialize(res.data)
      let finalNotifications = []
      if (page === 1) {
        finalNotifications = [...notifications]
      } else {
        finalNotifications = [...this.state.notifications, ...notifications]
      }
      let hasUnread = this.state.hasUnread
      if (!this.state.hasLoaded) {
        hasUnread =
          finalNotifications &&
          finalNotifications.length > 0 &&
          finalNotifications[0].read === false
      }
      this.setState({
        notifications: finalNotifications,
        pagination: { ...res.data.pagination },
        loading: false,
        hasLoaded: true,
        hasUnread: hasUnread,
      })
      return notifications
    } catch (err) {
      this.setState({ loading: false })
      return false
    }
  }

  markAllAsReadNotification = async () => {
    try {
      const res = await api.put(`/notifications/mark_all_as_read`)
      if (res.status === 204) {
        toastSuccess("All notifications marked as read")
        const { notifications } = this.state
        const readNotifications = notifications.map(single => ({
          ...single,
          read: true,
        }))
        this.setState({
          hasUnread: false,
          notifications: [...readNotifications],
        })
      }
      return true
    } catch (err) {
      console.error(err)
      toastError("Could not mark read at the moment")
      return false
    }
  }
}

export default NotificationStore
